import React, { useRef, useState, useEffect, useContext } from 'react'
import axios from 'axios'
import { 
    Container,
    OptionDiv,
    OptionText
 } from './style'
import UserContext from '../../../../contexts/UserContext'
import StockContext from '../../../../contexts/StockContext';

interface StockDropdwonMenu {
  text: string;
  field: string;
  onChange: (value: string) => void
}

const StockDropdown: React.FC<StockDropdwonMenu> = (props) => {
  const { token } = useContext(UserContext)
  const { stock, setStock } = useContext(StockContext)
  const [ options, setOptions ] = useState<string[]>([])

  useEffect(() => {
    let endpoint = ''
    if (props.field !== 'density'){
      endpoint = `${process.env.REACT_APP_BASE_URL}/${props.field}`
    } else {
      endpoint = `${process.env.REACT_APP_BASE_URL}/material/${props.field}`
    }
    axios.get(endpoint, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      setOptions(response.data)
    })
    .catch((error) => {
      console.log('Ocorreu um erro ao obter os dados do estoque', error)
    })
  }, [])

  let filteredOptions = options
  filteredOptions = filteredOptions.filter(value => value !== null && value !== '')
  if (props.text !== "" && props.text !== null){
    filteredOptions = filteredOptions.filter(str => str.toLowerCase().includes(props.text.toLowerCase()))
  }

  return (
      <Container onMouseDown={(e) => e.preventDefault()} className={filteredOptions.length == 0 ? "empty" : ""}>
          {filteredOptions.map((header, index) => 
            <OptionDiv key={index} onClick={() => props.onChange(header)}>
              <OptionText>{header}</OptionText>
            </OptionDiv>
          )}
      </Container>
  )
}

export default StockDropdown